import { createFileRoute } from "@tanstack/react-router";
import { AccountsScreen } from "../-accounts/AccountsScreen";

export const Route = createFileRoute("/admin/accounts/")({
  staticData: { title: "Accounts" },
  component: AccountsScreen,
});
